import {
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { UrlService } from '@uirouter/core';

@Component({
  selector: 'ap-force-load-angular',
  template: '',
})
export class ForceLoadAngularComponent implements OnInit {
  static readonly ajsComponentName = 'apForceLoadAngular';
  @Output() angularInitialized = new EventEmitter();

  constructor(
    private urlService: UrlService,
  ) {
  }

  ngOnInit() {
    this.urlService.listen();
    this.urlService.sync();

    this.angularInitialized.emit();
  }
}
